import { inject, onBeforeUnmount } from "vue";
const SHEET_LEADING_CONTROL_CLASS = "size-8 rounded-input bg-muted";
const SHEET_LAYER_NESTED = Symbol("kontySheetLayerNested");
const SHEET_LAYER_GUARD = Symbol("kontySheetLayerGuard");
const SHEET_ELEVATED = Symbol("kontySheetElevated");
function useSheetLayer() {
  return { nested: inject(SHEET_LAYER_NESTED, false) };
}
function useSheetLayerGuard() {
  if (inject("kontyBackoffice", false)) return;
  const setGuarded = inject(SHEET_LAYER_GUARD, null);
  if (!setGuarded) return;
  setGuarded(true);
  onBeforeUnmount(() => setGuarded(false));
}
export {
  SHEET_ELEVATED,
  SHEET_LAYER_GUARD,
  SHEET_LAYER_NESTED,
  SHEET_LEADING_CONTROL_CLASS,
  useSheetLayer,
  useSheetLayerGuard
};
//# sourceMappingURL=index48.js.map
